<template>
    <full-screen-layout>
        <template #header class="max-w-7xl mx-auto">
            <div class="mx-auto w-2/3 px-4">
                <h2
                    class="font-semibold text-xl text-gray-800 leading-tight mb-2"
                >
                    Please verify your phone number
                </h2>
                <p class="text-gray-700 text-base mb-4">
                    We are requiring that all customers complete a phone number
                    verification process. This verification is required by our
                    messaging provider in order to comply with telecom
                    standards.
                </p>
                <p class="text-gray-700 text-base mb-4">
                    If you have any issues completing this verification, please
                    contact us at
                    <a href="mailto:contact@textspot.io" class="underline"
                        >contact@textspot.io</a
                    >
                    for assistance.
                </p>
            </div>
        </template>
        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="mx-auto w-2/3 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg sm:p-6 lg:p-8">
                    <div v-show="step === 1">
                        <div class="">
                            <label for="phone" class="mb-1 flex items-center">
                                <span class="mr-4"
                                    >Your Mobile Phone Number</span
                                >
                                <span
                                    class="text-sm text-gray-400 font-normal flex items-center"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'question-circle']"
                                        class="text-lg mr-2"
                                    />
                                    <span
                                        >We will send you a text message to
                                        verify your account.<br />VoIP numbers
                                        are not permitted.</span
                                    >
                                </span>
                            </label>
                            <jet-input
                                class="mb-4"
                                v-model="phone"
                                name="phone"
                                placeholder="(555) 555-1234"
                                id="phone"
                                v-mask="'(###) ###-####'"
                            ></jet-input>
                            <p class="text-gray-700 text-sm mb-4">
                                <font-awesome-icon :icon="['far', 'lock']" />
                                Your phone number will <strong>never</strong> be
                                sold or shared with a third party.
                            </p>
                            <jet-button
                                @click.native="sendVerificationCode()"
                                :disabled="buttonDisabled"
                            >
                                <font-awesome-icon
                                    :icon="['far', 'spinner']"
                                    class="fa-spin"
                                    v-show="false"
                                />
                                Send Code
                            </jet-button>
                        </div>
                    </div>
                    <div v-show="step === 2">
                        <p>
                            Your TextSpot verification code has been sent to
                            {{ phone }}. Enter your code below.
                        </p>
                        <div class="mt-4 mb-1 block">
                            <label for="code" class="mb-2"
                                >Verification Code</label
                            >
                            <jet-input
                                v-model="code"
                                name="code"
                                id="code"
                                class="mb-4"
                            ></jet-input>
                            <div class="flex justify-between">
                                <div class="flex">
                                    <jet-button
                                        @click.native="checkVerificationCode()"
                                        :disabled="buttonDisabled"
                                    >
                                        <font-awesome-icon
                                            :icon="['far', 'spinner']"
                                            class="fa-spin"
                                            v-show="false"
                                        />
                                        Verify
                                    </jet-button>
                                    <!--                                    <button class="ml-4 text-sm text-gray-600 hover:text-gray-500 hover:underline" @click.native="resendCode">Resend Code</button>-->
                                </div>
                                <button
                                    v-if="attempts > 1"
                                    class="ml-4 text-sm text-gray-600 hover:text-gray-500 hover:underline"
                                    @click="back()"
                                >
                                    Try a different phone number
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-show="hasErrors">
                        <ul
                            class="mt-4 p-4 rounded list-disc list-inside bg-red-100 text-red-600"
                        >
                            <template v-for="error in errors">
                                <li v-for="e in error">{{ e }}</li>
                            </template>
                        </ul>
                    </div>
                </div>
                <p
                    class="block rounded text-gray-700 text-base mb-4 italic text-sm p-4 mt-8"
                >
                    All of your existing messages will be sent as scheduled, but
                    you will not be able to schedule any new messages until your
                    phone number has been verified.
                </p>
            </div>
        </div>
    </full-screen-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "../../Jetstream/Button";

import axios from "axios";

export default {
    components: { AppLayout, JetButton },
    name: "VerifyPhone",
    props: [],
    mounted() {},
    data() {
        return {
            step: 1,
            attempts: 0,
            phone: "",
            code: "",
            buttonDisabled: false,
            errors: {}
        };
    },
    computed: {
        hasErrors() {
            return !_.isEmpty(this.errors);
        }
    },
    methods: {
        back() {
            this.step = 1;
            this.code = "";
            this.errors = {};
        },
        sendVerificationCode() {
            let vm = this;
            vm.buttonDisabled = true;

            axios
                .post(route("send-verification-code"), {
                    phone_number: vm.phone
                })
                .then(function(response) {
                    vm.errors = {};
                    vm.step = 2;
                    vm.buttonDisabled = false;
                })
                .catch(function(error) {
                    vm.errors = error.response.data.errors;
                    vm.buttonDisabled = false;
                });
        },

        checkVerificationCode() {
            let vm = this;
            vm.buttonDisabled = true;

            axios
                .post(route("check-verification-code"), {
                    code: vm.code
                })
                .then(function(response) {
                    vm.$toasted.show(`Your number has been verified!`, {
                        position: "bottom-right",
                        type: "success",
                        duration: 5000
                    });
                    vm.errors = {};
                    vm.buttonDisabled = false;
                    vm.$inertia.visit("/");
                })
                .catch(function(error) {
                    vm.attempts++;
                    vm.errors = error.response.data.errors;
                    vm.buttonDisabled = false;
                });
        }
    }
};
</script>

<style></style>
